export const setLocation = (state, data) => {
  state.location = data
}
export const setUserInfo = (state, data) => {
  state.userInfo = data
}